import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './App.css';
import Layout from './main/coreModules/Layout/Layout';

function App() {
  return (
    <div className={'alpha-perceptron'}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout activePage='Main' />} />
          <Route path="/products" element={<Layout activePage='Products' />} />
          <Route path="/research" element={<Layout activePage='Research' />} />
          <Route path="/contact" element={<Layout activePage='Contact' />} />
          <Route path="/about" element={<Layout activePage='About' />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

